
export default function Users() {
    return (
        <h1>Dashboard</h1>
    )
}